import { Layout } from "antd";
import { PureComponent, ReactNode } from "react";
import { productCache } from "utils/cache/productCache";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { ProviderCodeEnum } from "utils/enums/ProviderCodeEnum";
import { strings } from "utils/localizedStrings";
const { Footer: AntFooter } = Layout;

export default class Footer extends PureComponent {
  private get partnerInfo() {
    return productCache?.getCache(CacheKeyEnum.partnerOfUser);
  }

  render(): ReactNode {
    const isNeciProvider =
      this.partnerInfo &&
      this.partnerInfo[0]?.providerCode === ProviderCodeEnum.neci;

    return (
      <AntFooter className="2xl:text-[14px] text-[11px] w-full mt-auto bg-white lg:text-left text-center">
        <p>
          {" "}
          Copyright © 2026 by{" "}
          <a
            target="_blank"
            className="hover:text-blue-600 font-[700] hover:underline"
            href={
              isNeciProvider
                ? "https://neci.vn"
                : "https://phuongquan.vn/introduce"
            }
            rel="noreferrer"
          >
            {isNeciProvider ? "Ky Nguyen Moi" : "Phuong Quan"}
          </a>
          . (Version {strings.GlobalLabels.VersionNumber}){" "}
        </p>
      </AntFooter>
    );
  }
}
